import css from '../../css/sidebar.module.css';
import {Typography,Box} from '@mui/material';
import { ProfileCard,SideBarLinks } from '../../ui-components';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SignOutIcon } from '../../svg/signout.svg';
import { useDispatch } from 'react-redux';
import { signOut } from '../../reduxSlice/userSlice';
import styled from '@emotion/styled';

export default function SideBar() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem('token');
    dispatch(signOut())
     navigate('/login');
  }

  return (
    <Box  component={"aside"} className={css.container}>
      <Typography  component={"div"} style={{ flexDirection:"column",  height:"calc(100vh - 53.88px)", gap:"10px"}}>
        <ProfileCard />
        <SideBarLinks />
        <SignOut>
          <span 
            onClick={handleSignOut} 
            style={{cursor:"pointer", display: 'flex', gap: '1rem', marginInlineStart: '2rem', marginBlockStart: '1rem'}} 
            className='signout'
          >
            <span>
              <SignOutIcon style={{width: '15px'}} />
            </span>
            <span style={{fontSize: '14px'}} className="iconsignout">
            Sign out </span>
          </span>
        </SignOut>         
      </Typography>
    </Box>
  )
}

const SignOut = styled.div`
  //margin-inline-start: 2rem;
  border-top: 5px solid #11643C;
`
